import { Helmet } from 'react-helmet-async';

/**
 * Injects JSON‑LD structured data.
 * Usage: <JsonLd data={{ …schema… }} />
 */
const JsonLd = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  </Helmet>
);

export default JsonLd; 